export default {
  type: 'admin',
  routes: [
    {
      method: 'GET',
      path: '/telegram-action/get-buttons',
      handler: 'telegramAction.getButtons',
      config: {}
    },
    {
      method: 'POST',
      path: '/telegram-action/trigger',
      handler: 'telegramAction.trigger',
      config: {}
    },
  ]
}
